import SocialHandle from '../SocialHandle';

const Footer = ()=>{
    return <div style={{backgroundColor:"#F4F5F7", marginTop:"25px"}}>
       <SocialHandle/>
       <p style={{display:"flex",justifyContent:"center"}}>(Last Updated on 01-01-2026)</p>
    </div>
}

export default Footer;